import { makeStyles } from "@material-ui/core/styles";

const useStyle = makeStyles(( ) => ({
  static: {
    "&:not(:hover) .hoverIcon": {
      // zIndex: -1,
      opacity: "0 !important",
    },
  },
  // overlay: {
  //   cursor: "inherit",
  //   animation: "pop 200ms cubic-bezier(0.18, 0.67, 0.6, 1.22)",
  //   opacity: 1,
  //   zIndex: 999,
  // },
}));

export default useStyle;